import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { titleDetailPath } from "shared/utils/titleNavigation";

export function useNavigateToTitle() {
  const navigate = useNavigate();
  return useCallback(
    (titleId: string) => {
      navigate(titleDetailPath(titleId));
    },
    [navigate]
  );
}
